import React from 'react';
import {
  Button,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../../HelpIcon';

import { sendBrowserNotification } from '../../../helpers/Notifications';

const AdminUserEditNotificationsDesktop = () => {
  const intl = useIntl();

  const sendTestNotification = () => {
    sendBrowserNotification({ type: 'Test', sound: true }, intl);
  };

  const requestPermissions = () => {
    Notification.requestPermission((permission) => {
      if (permission === 'granted') {
        window.location.reload();
      }
    });
  };

  if (!('Notification' in window)) {
    return null;
  }

  return (
    <>
      <hr />
      <h5>
        {intl.formatMessage({ defaultMessage: 'Desktop notifications' })}
      </h5>
      {Notification.permission === 'granted' ? (
        <p>
          {intl.formatMessage({ defaultMessage: 'Desktop notifications are enabled.' })}{' '}
          <Button
            size="sm"
            onClick={sendTestNotification}
          >
            {intl.formatMessage({ defaultMessage: 'Send test notification' })}
          </Button>
        </p>
      ) : (
        <p>
          {intl.formatMessage({
            defaultMessage: 'To receive desktop notifications you need to give Stockpress permissions.',
          })}{' '}
          <Button
            size="sm"
            onClick={requestPermissions}
          >
            {intl.formatMessage({ defaultMessage: 'Grant permissions' })}
          </Button>
          <br />
          <span className="sub">
            {intl.formatMessage({
              defaultMessage: `If the button is not clickable, please click the lock icon in your 
                browser bar to grant permissions.`,
            })}
            <HelpIcon
              id="help-notification-permissions"
              url="https://help.stockpress.co/en/articles/7828316-configure-your-stockpress-notifications"
            />
          </span>
        </p>
      )}
      <hr />
    </>
  );
};

export default AdminUserEditNotificationsDesktop;
